"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ecommerce_1 = require("../../api/ecommerce");
const AuthorizationStore_1 = __importDefault(require("../../common/js/stores/AuthorizationStore"));
const CustomerType_1 = __importDefault(require("../enums/CustomerType"));
const money_1 = require("../helper/money");
const LineItemPrice = ({ currency, lineItem }) => {
    const price = lineItem?.price?.unitPrice ?? 0;
    const formattedPrice = (0, money_1.moneyFormat)(price, currency);
    const showListPrice = CustomerType_1.default.customerDiscount === AuthorizationStore_1.default.customerType &&
        lineItem.payload?.zkpCartItemGroup === ecommerce_1.LineItemPayloadZkpCartItemGroupEnum.Products;
    if (!showListPrice) {
        return react_1.default.createElement(react_1.default.Fragment, null, formattedPrice);
    }
    const listPrice = lineItem.price?.listPrice?.price ?? null;
    const formattedListPrice = null !== listPrice ? (0, money_1.moneyFormat)(listPrice, currency) : null;
    const hasDifferentListPrice = null !== formattedListPrice && formattedListPrice !== formattedPrice;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        hasDifferentListPrice ? (react_1.default.createElement("span", { className: "znd-product-price__normal-price mr-1" },
            "(",
            formattedListPrice,
            ")")) : null,
        formattedPrice));
};
exports.default = LineItemPrice;
